import { SpecialCommissionsSettingsRuleType } from "./enums";

export const isRateRuleType = (type?: SpecialCommissionsSettingsRuleType) =>
  type === SpecialCommissionsSettingsRuleType.NETTO_POINTS_RATE ||
  type === SpecialCommissionsSettingsRuleType.COMMISSION_AMOUNT_RATE;
